import VisibilityIcon from "@mui/icons-material/Visibility";
import { FormHelperText, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import {
  getAreaByTalukaPostBodyUpdated,
  getAreaByUserType,
} from "../../Slice/area.slice";
import {
  getCategory,
  getCategoryByProductRateStructure,
} from "../../Slice/category.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getProductByCategory } from "../../Slice/product.slice";
import { getRegion } from "../../Slice/region.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";

import dayjs from "dayjs";
import { SalesTeamLeaveJson } from "../../DynamicFormsJson/MastersJSON/salesTeamLeaveJson";
import { getLeaveBalaceBySalesTeam } from "../../Slice/LeaveType.slice";
import {
  getAuthorityWiseUnderSalesTeam,
  getUnderSalesTeamList,
} from "../../Slice/salesExecutive.slice";
import AttachFile from "../../components/Comman/AttachFile";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { withRouter } from "../../components/withRouter";
import { titleColor } from "../../config/ColorObj";
import { imageUrl } from "../../config/Url";
import { mandatoryCheck, ValidationCheck } from "../../config/ValidationCheck";
import endpoint from "../../config/endpoints";
import {
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";
import { apiGet, apiPost, apiPostForImage } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
class SalesTeamLeaveForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formErrors: {},
      leaveData: {},
      fileName: "",
      fieldData: { leaveFor: "0" },
      dynamicMasterData: {
        employeeDetail: this.props.salesTeamList?.salesExecutive,
        leaveTypeDetail: this.props.leaveList?.leaveBalanceBySalesTeam,
      },
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.salesTeamList !== nextProps.salesTeamList) {
      if (
        this.props.salesTeamList?.salesExecutive !==
        nextProps.salesTeamList?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            employeeDetail: nextProps.salesTeamList?.salesExecutive,
          },
        });
      }
    }
    if (this.props.leaveList !== nextProps.leaveList) {
      if (
        this.props.leaveList?.leaveBalanceBySalesTeam !==
        nextProps.leaveList?.leaveBalanceBySalesTeam
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            leaveTypeDetail: nextProps.leaveList?.leaveBalanceBySalesTeam,
          },
        });
      }
    }
  }

  getListById = async (data) => {
    const { getLeaveBalaceBySalesTeam, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      if (data.salesTeam && data.salesTeam != "") {
        showLoador({ loador: true });
        await getLeaveBalaceBySalesTeam({
          salesTeamId: data.salesTeam,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            let responseData = response.length !== 0 ? response[0] : {};
            this.setState({ leaveData: responseData });
          }
        });
      }
    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  };

  async componentDidMount() {
    const {
      getUnderSalesTeamList,
      getAuthorityWiseUnderSalesTeam,
      showLoador,
      showNotification,
    } = this.props;
    const getLeaveAuthorityWiseData = localStorage.getItem(
      "getLeaveAuthorityWiseData"
    );

    if (navigator.onLine) {
      if (getLeaveAuthorityWiseData == 1) {
        showLoador({ loador: true });
        await getAuthorityWiseUnderSalesTeam({ flag: 0 }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      } else {
        showLoador({ loador: true });
        await getUnderSalesTeamList().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  }

  checkValidationOnSubmit = () => {
    const { fieldData } = this.state;

    if (dayjs(fieldData.toDate).isBefore(dayjs(fieldData.fromDate))) {
      this.props.showNotification({
        msg: "To Date cannot be less than From Date",
        severity: "error",
      });
      return;
    }

    const mandatoryCheckErrors = mandatoryCheck({
      fieldData,
      fieldMeta: SalesTeamLeaveJson.fieldMeta,
    });
    this.setState({
      formErrors: mandatoryCheckErrors.formErrors,
    });

    if (mandatoryCheckErrors.formValid) {
      const ValidationCheckErrors = ValidationCheck({
        fieldData,
        fieldMeta: SalesTeamLeaveJson.fieldMeta,
      });
      this.setState({
        formErrors: ValidationCheckErrors.formErrors,
      });
      return ValidationCheckErrors.formValid;
    } else {
      return false;
    }
  };

  onDataChange = (fieldName, newValue) => {
    const { fieldData, formData, leaveData } = this.state;

    //Comment By Tejas - (Pt. Akash Sir)
    // if (fieldName === "leaveType") {
    //     if (leaveData && leaveData.balanceLeave == 0) {
    //         this.props.showNotification({ msg: "Leave balance is 0. You are not eligible to apply for leave.", severity: "error" })
    //     }
    // }

    const dataToSearch = {};
    const dataToReset = { ...this.state.fieldData };
    SalesTeamLeaveJson.fieldMeta.map((currentField) => {
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");

        masterKeyList.map((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
          return null;
        });

        this.getListById(dataToSearch);
      }
      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.map((key) => {
          if (key == fieldName && dataToReset[key]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }
      return null;
    });

    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };

  changeH = (fileName, name, index) => {
    this.setState({
      ...this.state,
      fileName: fileName,
    });
  };

  onClickViewPreview = (e, row) => {
    e.stopPropagation();
    const url = URL.createObjectURL(row);
    window.open(url);
  };

  onSave = (dataToSave) => {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      apiPost({
        url: endpoint.leaveApply+"/save-with-msg",
        postBody: dataToSave,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if(data?.data?.error) {
            showNotification({ msg: data?.data?.message || saveFailedMsg, severity: "error" });
          } else {
            showNotification({ msg: savemsg });
            this.props.navigate(-1);
          }
        } else {
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSubmitData = async () => {
    const { showLoador, showNotification } = this.props;
    const { fieldData, fileName, leaveData } = this.state;

    if (this.checkValidationOnSubmit()) {
      const fromDateWithFormat = dayjs(fieldData.fromDate).format("DD-MM-YYYY");
      const toDateWithFormat = dayjs(fieldData.toDate).format("DD-MM-YYYY");

      const from = dayjs(fieldData.fromDate);
      const to = dayjs(fieldData.toDate);

      const daysDifference = to.diff(from, "day") + 1;

      // Comment By Ritesh
      // if (leaveData.balanceLeave < (fieldData.leaveFor == 0 ? daysDifference : (daysDifference) * 0.5)) {
      //     showNotification({ msg: "Leave duration exceeds the available leave balance, so you cannot apply for leave", severity: "error" });
      //     return
      // }

      let dataToSave = {};

      let fileNameData = "";

      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          if (fileName && fileName !== "") {
            fileNameData =
              dayjs(fileName.lastModifiedDate).format("hh:mm:ss") +
              fileName.name;

            const formData = new FormData();
            formData.append("file", fileName);
            formData.append("imageName", fileNameData);

            showLoador({ loador: true });
            await apiPostForImage({
              url: endpoint.uploadImage,
              postBody: formData,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (success) {
              } else {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            });
          }

          let userStockStakeHolderTypeId =
            localStorage.getItem("userStockStakeHolderTypeId") &&
            localStorage.getItem("userStockStakeHolderTypeId");

          let userId =
            localStorage.getItem("userId") && localStorage.getItem("userId");

          dataToSave = {
            salesTeam: {
              id: fieldData.salesTeam,
            },
            leaveType: {
              id: fieldData.leaveType,
            },
            authoritySalesPersonId: userId,
            authoritySalesPersonTypeId: userStockStakeHolderTypeId,
            fromDate: fromDateWithFormat,
            toDate: toDateWithFormat,
            leaveReason: fieldData.subject,
            description: fieldData.description,
            noOfDays:
              fieldData.leaveFor == 0 ? daysDifference : daysDifference * 0.5,
            status: 2,
            isActive: 1,
            leaveCancelRemark: "",
            attachFile: fileNameData ? fileNameData : "",
          };

          showLoador({ loador: true });
          await apiGet({
            url:
              endpoint.leaveApply +
              "/check-applicable-or-not?salesTeamId=" +
              fieldData.salesTeam +
              "&fromDate=" +
              fromDateWithFormat +
              "&toDate=" +
              toDateWithFormat,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              if (data && data.data && data.data.statusCode == 500) {
                showNotification({
                  msg: "Leave Already Applied",
                  severity: "error",
                });
              } else {
                this.onSave(dataToSave);
              }
            }
          });
        }
      });
    }
  };

  render() {
    const {
      dynamicMasterData,
      formErrors,
      fieldData,
      open,
      fileName,
      leaveData,
    } = this.state;

    return (
      <>
        {!open && (
          <>
            <Paper
              sx={{
                padding: 2,
              }}
              elevation={0}
            >
              <DynamicFormWithoutValidation
                dynamicMasterData={dynamicMasterData}
                screenTitle={SalesTeamLeaveJson.screenTitle}
                fieldMeta={SalesTeamLeaveJson.fieldMeta}
                apiBaseURL={SalesTeamLeaveJson.apiBaseURL}
                formErrors={formErrors}
                showSaveBtn={SalesTeamLeaveJson.showSaveBtn}
                showSaveBtnMain={false}
                getListById={this.getListById}
                getByIdApi={true}
                callApi={true}
                fieldData={fieldData}
                onDataChange={this.onDataChange}
                showBackToList={true}
              />
              <Grid
                item
                sm={6}
                xs={12}
                md={6}
                lg={6}
                container
                justifyContent="space-between"
              >
                <Grid item xs={12} md={5} sm={5}>
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: titleColor }}
                    label="Select Image:"
                  />
                </Grid>
                <Grid item xs={12} md={7} sm={7}>
                  <AttachFile name={"file"} fileName={this.changeH} />
                  &nbsp; {fileName !== "" ? fileName.name : ""}
                  &nbsp;{" "}
                  {fileName !== "" ? (
                    <MyComponentWithIconProps
                      statusImage={VisibilityIcon}
                      color="primary"
                      fontSize="medium"
                      title="View"
                      onClick={
                        this.props.params.id && imageSelect
                          ? (e) => this.onClickViewPreview(e, fileName)
                          : this.props.params.id
                          ? () => {
                              window.open(imageUrl + fileName.name, "_blank");
                            }
                          : (e) => this.onClickViewPreview(e, fileName)
                      }
                    />
                  ) : (
                    <FormHelperText error>
                      {formErrors["imageError"] ? formErrors["imageError"] : ""}
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
              <br />

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="right"
              >
                <ButtonCompo
                  size="medium"
                  type="button"
                  variant="contained"
                  name="Apply For Leave"
                  onClick={this.onSubmitData}
                />
              </Grid>
            </Paper>
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesTeamList: state.salesExecutive,
  leaveList: state.leaveType,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getProductByCategory,
  getCategory,
  getRegion,
  getStateByRegion,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBodyUpdated,
  getAreaByUserType,
  getCategoryByProductRateStructure,
  getUnderSalesTeamList,
  getLeaveBalaceBySalesTeam,
  getAuthorityWiseUnderSalesTeam,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SalesTeamLeaveForm);
